import { estadoLegible, formatoEuros, type Nota } from '../api';

export interface NotaPintable extends Nota {
  /** Referencia local si todavía no ha subido a Gextia. */
  ref: string | number;
  pendiente: boolean;
}

/**
 * Una nota en la lista.
 *
 * La papelera solo aparece si se puede borrar, que es lo mismo que decir en
 * borrador: en las demás no hay nada que ofrecer y un icono desactivado solo
 * invita a pulsarlo para descubrir que no.
 */
export function TarjetaNota({
  nota,
  alAbrir,
  alBorrar,
}: {
  nota: NotaPintable;
  alAbrir: () => void;
  alBorrar?: () => void;
}) {
  const estado = estadoLegible(nota.state);
  const sePuedeBorrar = alBorrar && (nota.pendiente || nota.state === 'draft');

  return (
    <li className="fila-con-accion">
      <button type="button" className="tarjeta" onClick={alAbrir}>
        <div className="tarjeta-fila">
          <span className="tarjeta-titulo">{nota.name}</span>
          {!nota.pendiente && <span className="importe">{formatoEuros(nota.totalAmount)}</span>}
        </div>
        <div className="tarjeta-meta">
          {nota.pendiente ? (
            <span className="marca espera">Pendiente de subir</span>
          ) : (
            <>
              <span className={`marca ${estado.tono}`}>{estado.texto}</span>{' '}
              {nota.expenseIds.length === 0
                ? '· sin gastos todavía'
                : `· ${nota.expenseIds.length} ${
                    nota.expenseIds.length === 1 ? 'gasto' : 'gastos'
                  }`}
            </>
          )}
        </div>
      </button>
      {/* Fuera del botón de la tarjeta, no dentro: un botón dentro de otro es
          HTML inválido y los lectores de pantalla se pierden. */}
      {sePuedeBorrar && (
        <button
          type="button"
          className="boton icono papelera"
          onClick={alBorrar}
          aria-label={`Borrar la nota ${nota.name}`}
        >
          🗑
        </button>
      )}
    </li>
  );
}
